import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import pencil from "assets/images/pencil.png";
import closeIcon from "assets/svg/closeIcon.svg";
import { ErrorHelperText } from "components/ErrorHelperText";

type Props = {
  title: string;
  isEditModal?: boolean;
  isErrorVisible?: boolean;
  isAddLogic?: boolean;
  error?: string;
  onClose?: () => void;
};

export const ModalHeader = ({
  isEditModal,
  title,
  isErrorVisible,
  error,
  isAddLogic = true,
  onClose,
}: Props) => {
  const theme = useTheme();
  return (
    <>
      <Box
        sx={{
          pl: "40px",
          pr: onClose ? "80px" : 0,
          position: "sticky",
          top: 0,
          zIndex: 2,
          width: "100%",
          minHeight: "50px",
          display: "flex",
          alignItems: "center",
          backgroundColor: theme.palette.secondary.main,
        }}
      >
        {isEditModal ? (
          <img
            src={pencil}
            alt="edit"
            style={{
              marginRight: "15px",
            }}
          />
        ) : isAddLogic ? (
          <Typography
            sx={{
              mr: "15px",
              color: "white",
              fontSize: "24px",
              fontWeight: 600,
            }}
          >
            +
          </Typography>
        ) : null}
        <Typography
          sx={{ color: "white", fontSize: "14px", fontWeight: "600" }}
        >
          {title}
        </Typography>
        {onClose && (
          <Box
            component="button"
            type="button"
            aria-label="Close modal"
            onClick={onClose}
            sx={{
              position: "absolute",
              top: "50%",
              right: "32px",
              width: "32px",
              height: "32px",
              p: 0,
              border: 0,
              transform: "translateY(-50%)",
              backgroundColor: "transparent",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "&:hover": { opacity: 0.7 },
              "&:focus-visible": {
                outline: "2px solid",
                outlineColor: "common.white",
                outlineOffset: "-2px",
              },
            }}
          >
            <Box
              component="img"
              src={closeIcon}
              alt=""
              sx={{ width: "26px", height: "26px" }}
            />
          </Box>
        )}
      </Box>
      {isErrorVisible && error && (
        <Box
          sx={{
            pl: "40px",
            width: "100%",
            height: "40px",
            display: "flex",
            alignItems: "center",
            backgroundColor: theme.palette.primary.light,
          }}
        >
          <ErrorHelperText isVisible={isErrorVisible} value={error} />
        </Box>
      )}
    </>
  );
};
